import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { Spacer } from 'app/layouts/generic';
import { useAnnouncementService } from 'hooks/iam/announcement';
import styles from './announcement.module.css';

export const AnnouncementCard = () => {
  const { fetchAnnouncements } = useAnnouncementService();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnnouncements({ query_string: 'sort_by=-created_on&population=1' })
      .then(({ announcements }) => setAnnouncement(announcements[0] || null))
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <>
        <BasicInfoSection>
          <Skeleton height={120} className={styles.skeleton} />
        </BasicInfoSection>
        <Spacer multiple={2} />
      </>
    );
  }

  if (!announcement) return null;

  const image = (
    <img className={styles.image} src={announcement.image_url} alt="Announcement" loading="lazy" />
  );

  return (
    <>
      <BasicInfoSection bodyClassName={styles.body}>
        {announcement.url ? (
          <a
            className={styles.link}
            href={announcement.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {image}
          </a>
        ) : (
          image
        )}
      </BasicInfoSection>
      <Spacer multiple={2} />
    </>
  );
};
